import axios, { AxiosError } from "axios";

import APIRoutes from "../../APIRoutes";

import ISonicMessage from "../../../common/classes/SonicMessage";

import { getChatRoot } from "../../../utils/GeneralUtils";
import { ChatErrorType } from "../../../common/classes/SonicChatErrorType";

/**
 * getMessgesAdmin
 *
 * Fetching messages in the admin page.
 *
 * @typedof MessageHistory
 * @property {string} id Chat room id
 * @property {ISonicMessage} messageHistory
 *
 * @param {string} auth_token The user's auth token, used for fetching data that requires certain privileges.
 * @param {string} senderId user_id of sender.
 * @param {string} recipientId user_id of recipient.
 * @param {number} page Number of message pages.
 * @param {boolean} isSelect Values for determining select and jikei.
 * @returns {Promise<MessageHistory[] | null>} An array of message.
 */

export const getMessagesAdmin = async (
  auth_token: string,
  senderId: string,
  recipientId: string,
  page: number,
  isSelect: boolean
): Promise<
  | {
      messageHistory: Array<ISonicMessage>;
      hasNext: boolean;
    }
  | ChatErrorType
> => {
  try {
    const res = await axios.get(
      getChatRoot(APIRoutes.chat.message, isSelect ? "admin" : "jikei"),
      {
        headers: {
          "X-Sonic-Auth": auth_token,
        },
        params: {
          senderId: senderId,
          recipientId: recipientId,
          page: page,
        },
      }
    );

    if (res.data.result === true) {
      return res.data.message;
    } else {
      return ChatErrorType.Unknown;
    }
  } catch (e) {
    if (e instanceof AxiosError && e.response?.status === 404) {
      return ChatErrorType.RoomNotFound;
    }
    return ChatErrorType.Unknown;
  }
};
